import { render } from "./CreateDiskModal.vue?vue&type=template&id=4f894c00&scoped=true"
import script from "./CreateDiskModal.vue?vue&type=script&lang=js"
export * from "./CreateDiskModal.vue?vue&type=script&lang=js"

import "./CreateDiskModal.vue?vue&type=style&index=0&id=4f894c00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f894c00"]])

export default __exports__